export default __webpack_public_path__ + "static/img/vogue_test_scene_1_0110.3d2e76c.webp";